import { clsx } from 'clsx'
import { Button } from 'component/Button'
import { ClickAction } from 'hook/useOnClickAction'
import { ReactNode } from 'react'
import { opt } from 'store/opt'
import css from './Segment.module.scss'

type Props = {
  action?: ClickAction | false
  active: boolean
  children: ReactNode
  className?: string
  disabled?: boolean
  fill?: boolean
  height?: number | string
  underline?: boolean
  filled?: boolean
}

export const Segment = (props: Props) => {
  const { action, active, children, disabled, fill, underline, filled } = props
  const text = !opt.tsum || opt.stand
  const primary = text && active
  const type = opt.stand ? css.stand : opt.tsum ? css.tsum : null
  const className = clsx(props.className, css.segment, underline && css.underline,
    type, active && css.active, fill && css.fill, filled && css.filled)
  const height = props.height ?? (opt.basic ? 64 : opt.stand ? 48 : 32)
  const round = opt.stand ? 8 : 4

  return <Button className={className} pad={0} height={height} round={round}
    text={text} primary={primary} disabled={disabled} action={action}>
    {children}
  </Button>
}
